'use client';

import { createContext, useContext, useEffect, useState } from "react";
const dashboardContext = createContext();

export const useDashboardContext = () => {
  return useContext(dashboardContext);
};

export function DashboardContextProvider({ children }) {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('sidebar_collapsed') === 'true';
    }
    return false;
  });

  // Global timer pause state for synchronized pause/resume across all components
  const [isTimerPaused, setIsTimerPaused] = useState(false);
  const [pausedAt, setPausedAt] = useState(null);

  // Server time offset for synchronized timer calculations
  // serverTimeOffset = serverTime - localTime
  const [serverTimeOffset, setServerTimeOffset] = useState(0);

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };
  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('sidebar_collapsed', String(next));
      return next;
    });
  };

  const pauseGlobalTimer = () => {
    setIsTimerPaused(true);
    setPausedAt(Date.now());
  };

  const resumeGlobalTimer = () => {
    setIsTimerPaused(false);
    setPausedAt(null);
  };

  return (
    <dashboardContext.Provider
      value={{
        toggleSidebar,
        setSidebarOpen,
        isSidebarOpen,
        isSidebarCollapsed,
        toggleSidebarCollapse,
        isTimerPaused,
        pausedAt,
        pauseGlobalTimer,
        resumeGlobalTimer,
        serverTimeOffset,
        setServerTimeOffset
      }}
    >
      {children}
    </dashboardContext.Provider>
  );
}
